import LevelAdapter from '@/classes/ProjectElementAdapters/LevelAdapter'
import BaseClusterGroupAdapter from '@/classes/ProjectElementAdapters/BaseClusterGroupAdapter'
export default class LevelsClusterGroupAdapter extends BaseClusterGroupAdapter {
  static get ElementAdapter() {
    return LevelAdapter
  }
}
